import React, { useState, useEffect } from 'react';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import { database, ref as dbRef, get, set, remove, push } from '../../firebase';
import { FaPlus, FaEdit, FaTrash, FaTimes, FaMapMarkerAlt } from 'react-icons/fa';

const AdminCustomerService = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    englishName: '',
    address: '',
    englishAddress: '',
    description: '',
    englishDescription: '',
    mapLink: ''
  });

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);

  useEffect(() => {
    loadCenters();
  }, []);

  const loadCenters = async () => {
    setLoading(true);
    try {
      const centersRef = dbRef(database, 'shivpratapmultistate/customer_service_centers');
      const snapshot = await get(centersRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setCenters(list);
      } else {
        setCenters([]);
      }
    } catch (error) {
      console.error('Error loading centers:', error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editingId) {
        // Edit existing
        const centerRef = dbRef(database, `shivpratapmultistate/customer_service_centers/${editingId}`);
        await set(centerRef, formData);
      } else {
        // Add new
        const centersRef = dbRef(database, 'shivpratapmultistate/customer_service_centers');
        const newRef = push(centersRef);
        await set(newRef, formData);
      }
      setShowModal(false);
      loadCenters();
      resetForm();
    } catch (error) {
      console.error('Error saving center:', error);
    }
    setLoading(false);
  };

  const handleEdit = (center) => {
    setFormData({
      name: center.name || '',
      englishName: center.englishName || '',
      address: center.address || '',
      englishAddress: center.englishAddress || '',
      description: center.description || '',
      englishDescription: center.englishDescription || '',
      mapLink: center.mapLink || ''
    });
    setEditingId(center.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this center?')) {
      setLoading(true);
      try {
        const centerRef = dbRef(database, `shivpratapmultistate/customer_service_centers/${id}`);
        await remove(centerRef);
        loadCenters();
      } catch (error) {
        console.error('Error deleting center:', error);
      }
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      englishName: '',
      address: '',
      englishAddress: '',
      description: '',
      englishDescription: '',
      mapLink: ''
    });
    setEditingId(null);
  };

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const migrateOldData = async () => {
    if (window.confirm('This will load default hardcoded centers into database. Are you sure?')) {
      setLoading(true);
      try {
        const defaultCenters = [
          { name: 'बलवडी (भा.) ग्राहक सेवा केंद्र', englishName: 'Balwadi (Bha.) Customer Service Center', address: 'विटा कुंडल रोड, स्वागत कमान जवळ, बलवडी (भा.)', englishAddress: 'Near Welcome Arch, Vita-Kundal Road, Balwadi (Bha.)', description: '', englishDescription: 'Customer Service Center at Balwadi (Bha.)', mapLink: 'https://maps.app.goo.gl/rmwZheVfQeaPCJ316' },
          { name: 'नागेवाडी ग्राहक सेवा केंद्र', englishName: 'Nagewadi Customer Service Center', address: 'सांगली जिल्हा मध्यवर्ती बँके जवळ, नागेवाडी', englishAddress: 'Near Sangli District Central Bank, Nagewadi', description: '', englishDescription: 'Customer Service Center at Nagewadi', mapLink: 'https://maps.app.goo.gl/9HmoDR3X4ws748yEA' },
          { name: 'पारे ग्राहक सेवा केंद्र', englishName: 'Pare Customer Service Center', address: 'ग्रामसचिवालय शेजारी, पारे', englishAddress: 'Next to Gram Secretariat, Pare', description: '', englishDescription: 'Customer Service Center at Pare', mapLink: 'https://maps.app.goo.gl/ondPoqwMUYDiQh9PA' },
          { name: 'वेजेगाव ग्राहक सेवा केंद्र', englishName: 'Vejegaon Customer Service Center', address: 'कै. हरीराम (दादा) निवृत्ती देवकर व्यासपीठ शेजारी, वेजेगाव', englishAddress: 'Next to Late Hariram (Dada) Nivrutti Devkar Dias, Vejegaon', description: '', englishDescription: 'Customer Service Center at Vejegaon', mapLink: 'https://maps.app.goo.gl/zXZfR2ruu44sP2EB7' },
          { name: 'करंजे ग्राहक सेवा केंद्र', englishName: 'Karunje Customer Service Center', address: 'कै. संपतराव माने, मोफत वाचनालय शेजारी,करंजे', englishAddress: 'Next to Late Sampatrao Mane Free Library, Karunje', description: '', englishDescription: 'Customer Service Center at Karunje', mapLink: 'https://maps.app.goo.gl/dRUDT2zHFETLXmF79?g_st=aw' },
          { name: 'बलवडी (खा.) ग्राहक सेवा केंद्र', englishName: 'Balwadi (Kha.) Customer Service Center', address: 'राहुल किराणा स्टोअर्स शेजारी, बलवडी (खा.)', englishAddress: 'Next to Rahul General Stores, Balwadi (Kha.)', description: '', englishDescription: 'Customer Service Center at Balwadi (Kha.)', mapLink: 'https://maps.app.goo.gl/b1cm4jmDhMmrLGre7?g_st=aw' }
        ];
        
        const centersRef = dbRef(database, 'shivpratapmultistate/customer_service_centers');
        for (const center of defaultCenters) {
          const newRef = push(centersRef);
          await set(newRef, center);
        }
        loadCenters();
      } catch (error) {
        console.error('Error migrating data:', error);
      }
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50">
      <AdminSidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <AdminNavbar sidebarCollapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      
      <div className={`transition-all duration-300 ease-in-out pt-20 ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <div className="p-4 lg:p-8 max-w-7xl mx-auto">
          
          <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-gray-800">Customer Service Centers</h1>
              <p className="text-gray-600">Manage all service center locations</p>
            </div>
            <div className="flex gap-2">
              {centers.length === 0 && (
                <button onClick={migrateOldData} className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors">
                  Load Default Data
                </button>
              )}
              <button onClick={openAddModal} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <FaPlus /> Add Center
              </button>
            </div>
          </div>

          {loading && !showModal ? (
            <div className="text-center py-10 text-gray-500">Loading centers...</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {centers.map(center => (
                <div key={center.id} className="bg-white rounded-xl shadow p-5 border border-gray-100 flex flex-col justify-between">
                  <div>
                    <h3 className="font-bold text-lg text-gray-800 mb-1">{center.englishName || center.name}</h3>
                    <p className="text-sm text-gray-500 mb-3">{center.name}</p>
                    <div className="flex items-start gap-2 text-gray-600 text-sm mb-2">
                      <FaMapMarkerAlt className="mt-1 flex-shrink-0 text-red-500" />
                      <span>{center.englishAddress || center.address}</span>
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
                    <button onClick={() => handleEdit(center)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                      <FaEdit />
                    </button>
                    <button onClick={() => handleDelete(center.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
              {centers.length === 0 && (
                <div className="col-span-full text-center py-12 bg-white rounded-xl border border-gray-100 text-gray-500">
                  No service centers found. Click 'Add Center' or 'Load Default Data' to get started.
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
              <h2 className="text-xl font-bold text-gray-800">{editingId ? 'Edit Center' : 'Add New Center'}</h2>
              <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-700">
                <FaTimes size={24} />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Marathi Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleInputChange} required className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">English Name</label>
                  <input type="text" name="englishName" value={formData.englishName} onChange={handleInputChange} required className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Marathi Address</label>
                  <textarea name="address" value={formData.address} onChange={handleInputChange} required rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">English Address</label>
                  <textarea name="englishAddress" value={formData.englishAddress} onChange={handleInputChange} rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Marathi Description</label>
                  <textarea name="description" value={formData.description} onChange={handleInputChange} rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">English Description</label>
                  <textarea name="englishDescription" value={formData.englishDescription} onChange={handleInputChange} rows="2" className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"></textarea>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Google Maps Link</label>
                <input type="url" name="mapLink" value={formData.mapLink} onChange={handleInputChange} className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>

              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200">
                  Cancel
                </button>
                <button type="submit" disabled={loading} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {loading ? 'Saving...' : 'Save Center'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCustomerService;
